import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9706 12.0546H9.02738L9.99949 8.81422L10.9706 12.0546Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM11.2438 6H8.7559L5.15234 18H7.24379L8.42739 14.0546H11.57L12.7524 18H14.8437L11.2438 6ZM17.9997 9H15.9958V11.0039H17.9997V9ZM17.9997 18V12H15.9997V18H17.9997Z"}}]};

const LogoAdobeIllustrateFilled = Vue.extend<IconProps>({
  name: 'LogoAdobeIllustrateFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-adobe-illustrate-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoAdobeIllustrateFilled;
